"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stack = void 0;
const ArrayEnumerable_1 = require("../enumerables/ArrayEnumerable");
const EnumerableFactory_1 = require("../utilities/EnumerableFactory");
const utilityFunctions_1 = require("../utilities/utilityFunctions");
class Stack extends ArrayEnumerable_1.ArrayEnumerable {
    constructor(collection) {
        const src = collection ? [...collection] : [];
        super(new EnumerableFactory_1.EnumerableFactory(), (0, utilityFunctions_1.getIterableGenerator)(src), src);
    }
    get length() {
        return this.srcArr.length;
    }
    clear() {
        this.srcArr.length = 0;
    }
    copyTo(array, arrayIndex) {
        const startArrayIndex = arrayIndex !== null && arrayIndex !== void 0 ? arrayIndex : 0;
        for (let i = 0, j = startArrayIndex; i < this.srcArr.length; i++, j++) {
            array[j] = this.srcArr[i];
        }
    }
    peek() {
        const item = this.tryPeek();
        if (item === null) {
            throw new Error('Stack is empty.');
        }
        return item;
    }
    pop() {
        const item = this.tryPop();
        if (item === null) {
            throw new Error('Stack is empty.');
        }
        return item;
    }
    push(item) {
        this.srcArr.push(item);
    }
    tryPeek() {
        if (this.srcArr.length === 0) {
            return null;
        }
        return this.srcArr[this.srcArr.length - 1];
    }
    tryPop() {
        var _a;
        return (_a = this.srcArr.pop()) !== null && _a !== void 0 ? _a : null;
    }
}
exports.Stack = Stack;
//# sourceMappingURL=Stack.js.map